module.exports = __webpack_public_path__ + "static/media/spotify-img.8312e59e.png";